import { Component, OnInit, Input } from '@angular/core';
import { MbIconModule } from '@am/moebius';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'search-status',
    templateUrl: './search-status.component.html',
    styleUrls: ['./search-status.component.scss'],
    standalone: true,
    imports: [
        NgFor,
        NgIf,
        MbIconModule,
    ],
})
export class SearchStatusComponent implements OnInit {
  @Input()
  items: any;
  @Input()
  show: boolean;

  constructor() {}

  ngOnInit() {}

  public trackByItems(index, _item) {
    return index;
  }
}
